import { render } from "./DashboardsIndicatorCards.vue?vue&type=template&id=3ad9677a&ts=true"
import script from "./DashboardsIndicatorCards.vue?vue&type=script&lang=ts"
export * from "./DashboardsIndicatorCards.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__